import { formatCurrency } from '../../Functions'
import DetailButton from './DetailButton'

const Table = ({state, openModalResume, openModalDetail}) => {
  return (
    <div className="row mt-2">
      <div className="card col-xxl-12">
        <div className={`table-responsive ${state.loading ? 'table-loading-overlay' : ''}`}>
          <table className="table table-row-bordered table-payment-datail">
            <thead className="fs-4 text-gray-400">
              <tr>
                <th>Rut</th>
                <th>Razón Social</th>
                <th>Tipo de Pago</th>
                <th>Estado</th>
                <th>Monto Factura o Boleta</th>
                <th>Fecha Proceso</th>
                <th>Fecha Pago</th>
                <th>Monto a Pago</th>
              </tr>
            </thead>
            <tbody className="fs-6 text-gray-800">
              {state.data.length > 0 && state.data.map((row, index) => (
                <tr key={row.correlativo}>
                  <td> {row.rut} </td>
                  <td> {row.razonsocial} </td>
                  <td> 
                    <div className="row">
                      <span style={{marginRight: '10px'}} className='col'> {row.tipopago} </span>
                      <span style={{ cursor: "pointer" }} className='col' onClick={() => openModalDetail(row)}>
                        <DetailButton title={row.tipopago} />
                      </span>
                    </div>
                    
                  </td>
                  <td> {row.estado} </td>
                  <td> 
                    <div className="row">
                      <span style={{marginRight: '10px'}} className='col'> {formatCurrency(row.montobruto)} </span>
                      <span style={{ cursor: "pointer" }} className='col' onClick={() => openModalResume(row)}>
                        <DetailButton title="Detalle" />
                      </span>
                    </div>
                  </td>
                  <td> {row.fechaproceso} </td>
                  <td> {row.fechapago} </td>
                  <td> {formatCurrency(row.montopago)} </td>
                </tr>))}
              {[...Array(10 - state.data.length)].map((row, index) => (
                <tr key={index}>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default Table